export default __webpack_public_path__ + "static/icon-18-4-1103204ec3ed67dbe76264958877ddab.png";